import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 border border-background-300/60">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">{appData.title}</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">{appData.description}</p>
            <div className="flex items-center justify-center md:justify-start gap-4">
              {appData.features.map((f) => (
                <span key={f} className="text-xs text-secondary-700 bg-secondary-100/80 px-3 py-1 rounded-full whitespace-nowrap">
                  <i className="ri-check-line mr-1"></i>{f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}